export enum IcsToastType {
    SUCCESS = 'https://s3-us-west-2.amazonaws.com/repository-leadics-test/leap/leap_icons/toast_icons/success_icon.svg',
    ERROR = 'https://s3-us-west-2.amazonaws.com/repository-leadics-test/leap/leap_icons/toast_icons/error_icon.svg',
    LOADING = 'https://s3-us-west-2.amazonaws.com/repository-leadics-test/leap/leap_icons/toast_icons/inProcess_icon.svg'
}
